import React from "react";
import { useNavigate } from "react-router-dom";
import { useT } from "./i18n";
import "./styles/questionnaire_page.css";

function QuestionnairePage() {
  const navigate = useNavigate();
  const t = useT();

  const goToChatSelection = () => {
    navigate("/chat-selection");
  };

  return (
    <div className="page-container">
      <div>
        <h1 className="title">{t.questionnaire.title}</h1>
        <p className="description">{t.questionnaire.description}</p>
        <div>
          <a
            href="https://hefr.eu.qualtrics.com/jfe/form/SV_3EFZIy5eFh0RJuS?Q_Language=EN-GB"
            target="_blank"
            rel="noopener noreferrer"
            className="button link-button"
          >
            {t.common.fillQuestionnaire}
          </a>
        </div>
        <div className="button-container">
          <button className="button" onClick={goToChatSelection}>
            {t.common.previous}
          </button>
        </div>
      </div>
    </div>
  );
}

export default QuestionnairePage;
